"use strict";

import React, { Fragment } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { isUserLoggin } from "../_helpers/auth.helper";
import AuthWrapper from "../components/pages/auth/AuthWrapper";
import { PrivateRoute } from "./PrivateRoute";
import Application from "../components/pages/Application";
import UiDemo from "../components/_uiStaging/UiDemo";
import { UiDashboard } from "../components/_uiStaging/pages/UiDashboard";
import { UiLogin } from "../components/_uiStaging/pages/UiLogin";
import { UiUserProfile } from "../components/_uiStaging/pages/UiUserProfile";
import { UiPopups } from "../components/_uiStaging/pages/UiPopups";
import { UiLoaders } from "../components/_uiStaging/pages/UiLoaders";
import { UiDashboardLoader } from "../components/_uiStaging/pages/loaders/UiDashboardLoader";
import { UiButtons } from "../components/_uiStaging/pages/UiButtons";
import { UiElements } from "../components/_uiStaging/pages/UiElements";
import { UiModalLoader } from "../components/_uiStaging/pages/loaders/UiModalLoader";
import { UiNetworkError } from "../components/_uiStaging/pages/loaders/UiNetworkError";
import { UiRecoveringUsernameLoader } from "../components/_uiStaging/pages/loaders/UiRecoveringUsernameLoader";
import { UiEmptyScreen } from "../components/_uiStaging/pages/loaders/UiEmptyScreen";
import { UiEmptyActivities } from "../components/_uiStaging/pages/loaders/UiEmptyActivities";
import { UiAccountInfoError } from "../components/_uiStaging/pages/loaders/UiAccountInfoError";
import { ForgotUsername } from "../components/pages/ForgotUsername/ForgotUsername";
import { UiFixedDeposits } from "../components/_uiStaging/pages/FixedDeposits/UiFixedDeposits";
import { UiFixedDepositEmpty } from "../components/_uiStaging/pages/FixedDeposits/UiFixedDepositEmpty";
import { UiFixedDepositsJointAccounts } from "../components/_uiStaging/pages/FixedDeposits/UiFixedDepositsJointAccounts";
import { UiLoans } from "../components/_uiStaging/pages/Loans/UiLoans";
import { UiLoansEmptyActivities } from "../components/_uiStaging/pages/Loans/UiLoansEmptyActivities";
import { UiLoansEmpty } from "../components/_uiStaging/pages/Loans/UiLoansEmpty";
import { UiAccounts } from "../components/_uiStaging/pages/Accounts/UiAccounts";
import { UiJointAccounts } from "../components/_uiStaging/pages/Accounts/UiJointAccounts";
import { UiAccountsEmpty } from "../components/_uiStaging/pages/Accounts/UiAccountsEmpty";
import { UiDashboardEmpty } from "../components/_uiStaging/pages/Accounts/UiDashboardEmpty";
import { UiAccountsFilterEmpty } from "../components/_uiStaging/pages/Accounts/UiAccountsFilterEmpty";
import { UiAccountDetailsPopup } from "../components/_uiStaging/pages/Accounts/UiAccountDetailsPopup";
import { UiResetPassword } from "../components/_uiStaging/pages/ResetPassword/UiResetPassword";
import { UiForgotUsername } from "../components/_uiStaging/pages/ResetPassword/UiForgotUsername";
import { UiPwResetEnterCardDetails } from "../components/_uiStaging/pages/ResetPassword/UiPwResetEnterCardDetails";
import { UiResetPasswordSuccess } from "../components/_uiStaging/pages/ResetPassword/UiResetPasswordSuccess";
import { UiEmptyCreditCard } from "../components/_uiStaging/pages/CreditCard/UiEmptyCreditCard";
import { UiCreditCards } from "../components/_uiStaging/pages/CreditCard/UiCreditCards";
import { UiBillPayments } from "../components/_uiStaging/pages/BillPayments/UiBillPayments";
import { UiBillPaymentform } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentform";
import { UiBillPaymentformFilled } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentformFilled";
import { UiTransactionConfirmation } from "../components/_uiStaging/pages/BillPayments/UiTransactionConfirmation";
import { UiBillPaymentSuccessful } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentSuccessful";
import { UiBillPaymentPending } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentPending";
import { UiBillPaymentUnSuccessful } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentUnSuccessful";
import { UiBillPaymentReceipt } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentReceipt";
import { UiBillPaymentsEmpty } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentsEmpty";
import { UiBillPaymentsCategoryEmpty } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentsCategoryEmpty";
import { UiBillPaymentsSearchEmpty } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentsSearchEmpty";
import { UiCardBillPaymentOwn } from "../components/_uiStaging/pages/BillPayments/UiCardBillPaymentOwn";
import { UiCardBillPaymentOwnFilled } from "../components/_uiStaging/pages/BillPayments/UiCardBillPaymentOwnFilled";
import { UiTransactionConfirmationOwnAdhoc } from "../components/_uiStaging/pages/BillPayments/UiTransactionConfirmationOwnAdhoc";
import { UiBillPaymentSuccessfulOwnAdhoc } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentSuccessfulOwnAdhoc";
import { UiBillPaymentReceiptOwnAdhoc } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentReceiptOwnAdhoc";
import { UiCardBillPaymentOther } from "../components/_uiStaging/pages/BillPayments/UiCardBillPaymentOther";
import { UiCardBillPaymentOtherBank } from "../components/_uiStaging/pages/BillPayments/UiCardBillPaymentOtherBank";
import { UiCardBillPaymentOtherBankFilled } from "../components/_uiStaging/pages/BillPayments/UiCardBillPaymentOtherBankFilled";
import { UiBillPaymentSuccessOtherBanks } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentSuccessOtherBanks";
import { UiBillPaymentReceiptOtherBanks } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentReceiptOtherBanks";
import { UiCardBillPaymentWithOutstanding } from "../components/_uiStaging/pages/BillPayments/UiCardBillPaymentWithOutstanding";
import { UiHistory } from "../components/_uiStaging/pages/History/UiHistory";
import { UiHistorySearchEmpty } from "../components/_uiStaging/pages/History/UiHistorySearchEmpty";
import { UiHistoryEmpty } from "../components/_uiStaging/pages/History/UiHistoryEmpty";
import { UiJointLoans } from "../components/_uiStaging/pages/Loans/UiJointLoans";
import { BillerFavouriteDashboard } from "../components/_uiStaging/pages/BillerFavourite/BillerFavouriteDashboard";
import { UiFundTransferDashboard } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferDashboard";
import { UiFundTransferDashboardFilled } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferDashboardFilled";
import { UiFundTransferSuccessful } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferSuccessful";
import { UiFundTransferUnSuccessful } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferUnSuccessful";
import { UiFundTransferReceipt } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferReceipt";
import { UiPopupNew } from "../components/_uiStaging/pages/UiPopupNew";
import { UiFundTransferSuccessfulNotification } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferSuccessfulNotification";
import { UiFundTransferDashboardEmptyScreen } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferEmptyScreen";
import { UiFundTransferOtherBankAccount } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherBankAccount";
import { UiFundTransferOtherBankSuccessful } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherBankSuccessful";
import { UiFundTransferTransactionConfirmation } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferTransactionConfirmation";
import { UiFundTransferOtherAccTransactionConfirmation } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherAccTransactionConfirmation";
import { UiFundTransferOtherAccReceipt } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherAccReceipt";
import { UiFundTransferOtherBankReceipt } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherBankReceipt";
import { UiFundTransferOtherBankTransactionConfirmation } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherBankTransactionConfirmation";
import { UiFundTransferOtherBankUnSuccessful } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherBankUnSuccessful";
import { UiFundTransferOtherBankPending } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherBankPending";
import { UiFundTransferCrossCurrency } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferCrossCurrency";
import { UiFundTransferCrossCurrencySuccess } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferCrossCurrencySuccess";
import { UiFundTransferCrossCurrencyConfirmation } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferCrossCurrencyConfirmation";
import { UiFundTransferCrossCurrencyUnSuccessful } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferCrossCurrencyUnSuccessful";
import { UiFundTransferCrossCurrencyReceipt } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferCrossCurrencyReceipt";
import { UiFundTransferCrossCurrencyFilled } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferCrossCurrencyFilled";
import { UiFavouriteBillPaymentform } from "../components/_uiStaging/pages/BillerFavourite/UiFavouriteBillPaymentform";
import { BillerFavouriteDashboardEmpty } from "../components/_uiStaging/pages/BillerFavourite/BillerFavouriteDashboardEmpty";
import { UiFavouriteBillPaymentformWithOutstanding } from "../components/_uiStaging/pages/BillerFavourite/UiFavouriteBillPaymentformWithOutstanding";
import { UiFavouriteBillPaymentsEmptyActivity } from "../components/_uiStaging/pages/BillerFavourite/UiFavouriteBillPaymentsEmptyActivity";
import { UiFavouriteBillPaymentsEmptyActivityFiltered } from "../components/_uiStaging/pages/BillerFavourite/UiFavouriteBillPaymentsEmptyActivityFiltered";
import { UiFavouriteBillPaymentEdit } from "../components/_uiStaging/pages/BillerFavourite/UiFavouriteBillPaymentEdit";
import { UiBillPaymentsEmptyFavourite } from "../components/_uiStaging/pages/BillerFavourite/UiBillPaymentsEmptyFavourite";
import { UiFundTransferHistorySuccessful } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferHistorySuccessful";
import { UiFundTransferHistoryUnSuccessful } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferHistoryUnSuccessful";
import { UiFundTransferHistoryPending } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferHistoryPending";
import { UiFundTransferPurpose } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferPurpose";
import { UiFundTransferPurposeConfirm } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferPurposeConfirm";

import { UiMyWallet } from "../components/_uiStaging/pages/MyWallet/UiMyWallet";
import { UiMyWalletEmpty } from "../components/_uiStaging/pages/MyWallet/UiMyWalletEmpty";
import { UiPayeeFavouriteForm } from "../components/_uiStaging/pages/PayeeFavourite/UiPayeeFavouriteForm";
import { UiPayeeFavouriteConfirmation } from "../components/_uiStaging/pages/PayeeFavourite/UiPayeeFavouriteConfirmation";
import { UiPayeeFavouriteSuccessful } from "../components/_uiStaging/pages/PayeeFavourite/UiPayeeFavouriteSuccessful";
import { UiPayeeFavouriteFormPayfromAccount } from "../components/_uiStaging/pages/PayeeFavourite/UiPayeeFavouriteFormPayfromAccount";
import { UiPayeeFavouriteEmtpyActivities } from "../components/_uiStaging/pages/PayeeFavourite/UiPayeeFavouriteEmtpyActivities";
import { UiPayeeFavouriteEmtpyActivitiesFiltered } from "../components/_uiStaging/pages/PayeeFavourite/UiPayeeFavouriteEmtpyActivitiesFiltered";
import { UiPayeeFavouriteFormEdit } from "../components/_uiStaging/pages/PayeeFavourite/UiPayeeFavouriteFormEdit";
import { UiCreditCardsDetailsError } from "../components/_uiStaging/pages/CreditCard/UiCreditCardsDetailsError";
import { TransferLimitDashboard } from "../components/_uiStaging/pages/Settings/TransferLimitDashboard";
import { UiApplicationSettings } from "../components/_uiStaging/pages/Settings/UiApplicationSettings";
import { UiNewPassword } from "../components/_uiStaging/pages/Settings/UiNewPassword";
import { UiCreateNewPassword } from "../components/_uiStaging/pages/Settings/UiCreateNewPassword";
import { UiOtpPreference } from "../components/_uiStaging/pages/Settings/UiOtpPreference";
import { UiTransferLimitPreference } from "../components/_uiStaging/pages/Settings/UiTransLimitPref";
import { UiOwnAccountTransfer } from "../components/_uiStaging/pages/Settings/UiOwnAccountTransfer";
import { UiAccountPreferences } from "../components/_uiStaging/pages/Settings/UiAccountPreferences";
import { ForgotPasswordWrapper } from "../components/pages/auth/ForgotPasswordWrapper";
import { UiAdmitLimitNull } from "../components/_uiStaging/pages/Settings/UiAdmitLimitNull";
import { UiTransferEmpty } from "../components/_uiStaging/pages/Settings/UiTransferEmpty";
import { AdminPasswordResetWrapper } from "../components/pages/auth/AdmiPasswordResetWrapper";
import { UiFundTransferOtherAccount } from "../components/_uiStaging/pages/FundTransfer/UiFundTransferOtherAccount";
import { UiOtpRadioDisable } from "../components/_uiStaging/pages/Settings/UiOtpRadioDisable";
import { UiNotificationSettingEmpty } from "../components/_uiStaging/pages/Settings/UiNotificationSettingEmpty";
import { UiNickNamesEmpty } from "../components/_uiStaging/pages/Settings/UiNickNamesEmpty";
import { UiCreditCardPreferenceEmpty } from "../components/_uiStaging/pages/Settings/UiCreditCardPreferenceEmpty";
import { UiDefaultAccountEmpty } from "../components/_uiStaging/pages/Settings/UiDefaultAccountEmpty";
import { UiAccountPreferencesEmpty } from "../components/_uiStaging/pages/Settings/UiAccountPreferencesEmpty";
import { UiNickNamesTabEmpty } from "../components/_uiStaging/pages/Settings/UiNickNamesTabEmpty";
import { UiCreditCardPreferences } from "../components/_uiStaging/pages/Settings/UiCreditCardPreferences";
import { UiSetAccountNickname } from "../components/_uiStaging/pages/Settings/UiSetAccountNickname";
import { UiSetDefaultAccount } from "../components/_uiStaging/pages/Settings/UiSetDefaultAccount";
import { UiChangeAccountNickname } from "../components/_uiStaging/pages/Settings/UiChangeAccountNickname";
import { UiNotificationSettings } from "../components/_uiStaging/pages/Settings/UiNotificationSettings";
import { UiOtpCbsRemove } from "../components/_uiStaging/pages/Settings/UiOtpCbsRemove";
import { BillerFavouriteDashboardEmptyWithSearch } from "../components/_uiStaging/pages/BillerFavourite/BillerFavouriteDashboardEmptyWithSearch";
import { UiNicBegin } from "../components/_uiStaging/pages/Registration/UiNicBegin";
import { UiRadioStepOne } from "../components/_uiStaging/pages/Registration/UiRadioStepOne";
import { UiAccountNoStepTwo } from "../components/_uiStaging/pages/Registration/UiAccountNoStepTwo";
import { UiPreferedStepFour } from "../components/_uiStaging/pages/Registration/UiPreferedStepFour";
import { UiVerificationProgress } from "../components/_uiStaging/pages/Registration/UiVerificationProgress";
import { UiUsernameStepFive } from "../components/_uiStaging/pages/Registration/UiUsernameStepFive";
import { UiPasswordStepSix } from "../components/_uiStaging/pages/Registration/UiPasswordStepSix";
import { UiNameStepSeven } from "../components/_uiStaging/pages/Registration/UiNameStepSeven";
import { UiAccountReady } from "../components/_uiStaging/pages/Registration/UiAccountReady";
import { UiTryAgain } from "../components/_uiStaging/pages/Registration/UiTryAgain";
import { UiDeditCardDetails } from "../components/_uiStaging/pages/Registration/UiDeditCardDetails";
import { UiOnboardCreditCardDetails } from "../components/_uiStaging/pages/Registration/UiOnboardCreditCardDetails";
import { UiNotCustomer } from "../components/_uiStaging/pages/Registration/UiNotCustomet";
import { UiFixedDeposit } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDeposit";
import { UiOpenFixedDeposit } from "../components/_uiStaging/pages/FixedDepositsOpening/UiOpenFixedDeposit";
import { UiOpenFixedDepositFilled } from "../components/_uiStaging/pages/FixedDepositsOpening/UiOpenFixedDepositFilled";
import { UiFixedDepositOpeningConfirm } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositOpeningConfirm";
import { UiFixedDepositOpeningSuccess } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositOpeningSuccess";
import { UiFixedDepositReceipt } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositReceipt";
import { UiSelectBankEmpty } from "../components/_uiStaging/pages/FundTransfer/UiSelectBankEmpty";
import { OnboardingWrapper } from "../components/pages/Onboarding/OnboardingWrapper";
import { UiFixedDepositAmountInterestConfirm } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositAmountInterestConfirm";
import { UiFixedDepositRenewAmountConfirm } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositRenewAmountConfirm";
import { UiFixedDepositClosure } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositClosure";
import { UiFixedDepositClosureSuccess } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositClosureSuccess";
import { UiBillPaymentSuccessfulWithNickname } from "../components/_uiStaging/pages/BillPayments/UiBillPaymentSuccessfulWithNickname";
import { UiFixedDepositClosureReceipt } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositClosureReceipt";
import { UiFixedDepositClosureConfirm } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFixedDepositClosureConfirm";
import { UiFdProgress } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFdProgress";
import { UiFdSomethingWrong } from "../components/_uiStaging/pages/FixedDepositsOpening/UiFdSomethingWrong";
import { UiSecureMailEmptyDashboard } from "../components/_uiStaging/pages/SecureMail/UiSecureMailEmptyDashboard";
import { UiSecureMailDashboard } from "../components/_uiStaging/pages/SecureMail/UiSecureMailDashboard";
import { UiCreateMail } from "../components/_uiStaging/pages/SecureMail/UiCreateMail";
import { UiCreateMailWithAttachment } from "../components/_uiStaging/pages/SecureMail/UiCreateMailWithAttachment";
import { UiSecureMailDashboardSearchEmpty } from "../components/_uiStaging/pages/SecureMail/UiSecureMailDashboardSearchEmpty";
import { UiViewMail } from "../components/_uiStaging/pages/SecureMail/UiViewMail";
import { UiViewMailClosed } from "../components/_uiStaging/pages/SecureMail/UiViewMailClosed";
import { UiSavingsGoalOpen } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalOpen";
import { UiCreateSavingsGoalsForm } from "../components/_uiStaging/pages/SavingsAccountOpen/UiCreateSavingsGoalsForm";
import { UiSavingsGoalOpeningConfirmation } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalOpeningConfirmation";
import { UiSavingsGoalOpeningSuccess } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalOpeningSuccess";
import { UiSavingsGoalReceipt } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalReceipt";
import { UiCreateSavingsGoal } from "../components/_uiStaging/pages/SavingsAccountOpen/UiCreateSavingsGoal";
import { UiOpenSavingsAccount } from "../components/_uiStaging/pages/Accounts/UiOpenSavingsAccount";
import { UiSavingsAccountOpeningConfirmation } from "../components/_uiStaging/pages/Accounts/UiSavingsAccountOpeningConfirmation";
import { UiSavingsAccountCreatedSuccess } from "../components/_uiStaging/pages/Accounts/UiSavingsAccountCreatedSuccess";
import { UiSavingsAccountSomethingWrong } from "../components/_uiStaging/pages/Accounts/UiSavingsAccountSomethingWrong";
import { UiSavingsAccountCreatedSuccess2 } from "../components/_uiStaging/pages/Accounts/UiSavingsAccountCreatedSuccess2";
import { UiSavingsAccountCreatedSuccess3 } from "../components/_uiStaging/pages/Accounts/UiSavingsAccountCreatedSuccess3";
import { UiSavingsGoalOpenEmpty } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalOpenEmpty";
import { UiSavingsGoalDetailEmpty } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalDetailEmpty";
import { UiSavingsGoalClosure } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalClosure";
import { UiSavingsGoalClosureConfirmation } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalClosureConfirmation";
import { UiSavingsGoalProgress } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalProgress";
import { UiSavingsGoalClosedSuccess } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalClosedSuccess";
import { UiSavingsGoalClosureReceipt } from "../components/_uiStaging/pages/SavingsAccountOpen/UiSavingsGoalClosureReceipt";
import { UiOpenFdPrincipalAmount } from "../components/_uiStaging/pages/SavingsAccountOpen/UiOpenFdPrincipalAmount";
import { UiPortfolioDashboard } from "../components/_uiStaging/pages/Portfolio/UiPortfolioDashboard";
import { UiNotificationsEmpty } from "../components/_uiStaging/pages/Notifications/UiNotificationsEmpty";
import { UiNotificationsError } from "../components/_uiStaging/pages/Notifications/UiNotificationsError";
import { UiPortfolioSavingsAccounts } from "../components/_uiStaging/pages/Portfolio/UiPortfolioSavingsAccounts";
import { UiPortfolioFixedDeposit } from "../components/_uiStaging/pages/Portfolio/UiPortfolioFixedDeposit";
import { UiServiceAccounts } from "../components/_uiStaging/pages/ServiceRequest/UiServiceAccounts";
import { UiServiceRequestStop } from "../components/_uiStaging/pages/ServiceRequest/UiServiceRequestStop";
import { UiStopChequeForm } from "../components/_uiStaging/pages/ServiceRequest/UiStopChequeForm";
import { UiServiceRequestConfirmation } from "../components/_uiStaging/pages/ServiceRequest/UiServiceRequestConfirmation";
import { UiServiceRequestSuccess } from "../components/_uiStaging/pages/ServiceRequest/UiServiceRequestSuccess";
import { UiServiceSomethingWrong } from "../components/_uiStaging/pages/ServiceRequest/UiServiceSomethingWrong";
import { UiLease } from "../components/_uiStaging/pages/Lease/UiLease";
import { UiServiceRequestEmpty } from "../components/_uiStaging/pages/ServiceRequest/UiServiceRequestEmpty";
import { UiServiceRequest } from "../components/_uiStaging/pages/ServiceRequest/UiServiceRequest";
import { UiServiceRequestFilterEmpty } from "../components/_uiStaging/pages/ServiceRequest/UiServiceRequestFilterEmpty";
import { UiLeaseEmpty } from "../components/_uiStaging/pages/Lease/UiLeaseEmpty";
import { UiServiceRequestForm } from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceRequestForm";
import { UiServiceRequestCommonConfirmation } from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceRequestCommonConfirmation";
import { UiServiceRequestDashboard } from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceRequestDashboard";
import { UiServiceRequestCommonEmpty } from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceRequestCommonEmpty";
import {
  UiServiceRequestCommon,
  UiServiceRequestStopCheque,
} from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceRequestStopCheque";
import { UiSecureMailPrintConversation } from "../components/_uiStaging/pages/SecureMail/UiSecureMailPrintConversation";
import { UiServiceRequestChequeBook } from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceRequestChequeBook";
import { UiServiceStopChequeRange } from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceStopChequeRange";
import { UiStopChequeConfirmation } from "../components/_uiStaging/pages/ServiceRequestCommon/UiStopChequeConfirmation";
import { UiTrafficFinesForm } from "../components/_uiStaging/pages/TrafficFines/UiTrafficFinesForm";
import { UiTrafficFinesTransactionConfirmation } from "../components/_uiStaging/pages/TrafficFines/UiTrafficFinesTransactionConfirmation";
import { UiTrafficFinesTransactionSuccessful } from "../components/_uiStaging/pages/TrafficFines/UiTrafficFinesTransactionSuccessful";
import { UiTrafficFinesTransactionUnsuccessful } from "../components/_uiStaging/pages/TrafficFines/UiTrafficFinesTransactionUnsuccessful";
import { UiTrafficFinesReceipt } from "../components/_uiStaging/pages/TrafficFines/UiTrafficFinesReceipt";
import { UiTrafficFines } from "../components/_uiStaging/pages/TrafficFines/UiTrafficFines";
import { UiSlTransactionConfirmation } from "../components/_uiStaging/pages/LPPOP/UiSlTransactionConfirmation";
import { UiLppopBillPaymentDashboard } from "../components/_uiStaging/pages/LPPOP/UiLppopBillPaymentDashboard";
import { UiSlCustomForm } from "../components/_uiStaging/pages/LPPOP/UiSlCustomForm";
import { UiSlCustomsSuccess } from "../components/_uiStaging/pages/LPPOP/UiSlCustomsSuccess";
import { UiSlCustomPending } from "../components/_uiStaging/pages/LPPOP/UiSlCustomPending";
import { UiSlCustomUnsuccess } from "../components/_uiStaging/pages/LPPOP/UiSlCustomUnsuccess";
import { UiSlCustomAlmostThere } from "../components/_uiStaging/pages/LPPOP/UiSlCustomAlmostThere";
import { UiIrdForm } from "../components/_uiStaging/pages/LPPOP/UiIrdForm";
import { UiAddUnregisteredBillerAsFavouriteSuccess } from "../components/_uiStaging/pages/FundTransfer/UiAddUnregisteredBillerAsFavouriteSuccess";
import { UiAddUnregisteredBillerAsFavouriteEndTransactionSuccess } from "../components/_uiStaging/pages/BillerFavourite/UiAddUnregisteredBillerAsFavouriteEndTransactionSuccess";
import { UiAddUnregisteredBillerAsFavouriteEndTransactionPending } from "../components/_uiStaging/pages/BillerFavourite/UiAddUnregisteredBillerAsFavouriteEndTransactionPending";
import { UiServiceRequestFailed } from "../components/_uiStaging/pages/ServiceRequest/UiServiceRequestFailed";
import { UiServiceDebitCardList } from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceDebitCardList";
import { UiViewChequeBookStatus } from "../components/_uiStaging/pages/ChequebookRequest/UiViewChequeBookStatus";
import { UiAccountStatement } from "../components/_uiStaging/pages/Accounts/UiAccountStatement";
import { UiServiceCountryList } from "../components/_uiStaging/pages/ServiceRequestCommon/UiServiceCountryList";
import { UiLoginFullLoader } from "../components/_uiStaging/pages/loaders/UiLoginFullLoader";
import { SchedulePaymentsDashboard, SchedulePaymentsMain } from "../components/_uiStaging/pages/SchedulePayments/SchedulePaymentsMain";
import { SchedulePaymentsPopup } from "../components/_uiStaging/pages/SchedulePayments/SchedulePaymentsPopup";
import { SchedulePaymentsDashboardEmpty, SchedulePaymentsMainEmpty } from "../components/_uiStaging/pages/SchedulePayments/SchedulePaymentsMainEmpty";
import { ScheduleDetail } from "../components/_uiStaging/pages/SchedulePayments/ScheduleDetail";
import { ScheduleDetailEmpty } from "../components/_uiStaging/pages/SchedulePayments/ScheduleDetailEmpty";
import { ScheduleDetailInsufficient } from "../components/_uiStaging/pages/SchedulePayments/ScheduleDetailInsufficient";
import { UiSchedulePaymentsSuccess } from "../components/_uiStaging/pages/SchedulePayments/UiSchedulePaymentsSuccess";
import { SchedulePaymentsMove } from "../components/_uiStaging/pages/SchedulePayments/SchedulePaymentsMove";
import { ScheduleDetailRetrySuccess } from "../components/_uiStaging/pages/SchedulePayments/ScheduleDetailRetrySuccess";
import { UiForgotPassword } from "../components/_uiStaging/pages/ForgotPassword/UiForgotPassword";
import { UiForgotUsernameLoader } from "../components/_uiStaging/pages/ForgotPassword/UiForgotUsernameLoader";
import { UiJoyRidePeekBalance } from "../components/_uiStaging/pages/JoyRide/UiJoyRidePeekBalance";
import { UiJoyRideBillPayments } from "../components/_uiStaging/pages/JoyRide/UiJoyRideBillPayments";
import { UiJoyRideSendMoney } from "../components/_uiStaging/pages/JoyRide/UiJoyRideSendMoney";

const RoutesComponent = (props) => {
  return (
    <Fragment>
      <Routes>
        <Route
          path="/"
          element={
            !isUserLoggin() ? (
              <AuthWrapper {...props} />
            ) : (
              <Navigate {...props} to="/app/dashboard" replace />
            )
          }
        />
        <Route path="forgot-username" element={<ForgotPasswordWrapper />} />

        <Route path="reset-password" element={<AdminPasswordResetWrapper />} />

        <Route path="onboarding-flow" element={<OnboardingWrapper />} />

        {/* Private Route for Application */}
        <Route
          path="/app/*"
          element={<PrivateRoute element={<Application />} />}
        />

        {/* UI Development Routes (Only in Development Mode) */}
        {process.env.NODE_ENV === "development" && (
          <>
            <Route path="/ui" element={<UiDemo />} />
            <Route path="/ui/dashboard" element={<UiDashboard />} />
            <Route path="/ui/login" element={<UiLogin />} />
            <Route path="/ui/accounts" element={<UiAccounts />} />
            <Route
              path="/ui/account-details-popup"
              element={<UiAccountDetailsPopup />}
            />
            <Route path="/ui/profile" element={<UiUserProfile />} />
            <Route path="/ui/popups" element={<UiPopups />} />
            <Route path="/ui/popupsnew" element={<UiPopupNew />} />
            <Route path="/ui/loaders" element={<UiLoaders />} />
            <Route path="/ui/buttons" element={<UiButtons />} />
            <Route
              path="/ui/dashboard-loader"
              element={<UiDashboardLoader />}
            />
            <Route path="/ui/modal-loader" element={<UiModalLoader />} />
            <Route
              path="/ui/login-full-loader"
              element={<UiLoginFullLoader />}
            />
            <Route
              path="/ui/recovering-uname-loader"
              element={<UiRecoveringUsernameLoader />}
            />
            <Route path="/ui/network-error" element={<UiNetworkError />} />
            <Route
              path="/ui/account-info-error"
              element={<UiAccountInfoError />}
            />
            <Route path="/ui/ui-elements" element={<UiElements />} />
            <Route
              path="/ui/ui-forget-username"
              element={<UiForgotUsername />}
            />
            <Route
              path="/ui/empty-activities"
              element={<UiEmptyActivities />}
            />
            <Route path="/ui/empty-screen" element={<UiEmptyScreen />} />
            <Route
              path="/ui/ui-forget-password-enter-card-details"
              element={<UiPwResetEnterCardDetails />}
            />
            <Route path="/ui/ui-reset-password" element={<UiResetPassword />} />
            <Route
              path="/ui/ui-reset-password-success"
              element={<UiResetPasswordSuccess />}
            />
            <Route
              path="/ui/ui-individual-account-empty"
              element={<UiAccountsEmpty />}
            />
            <Route path="/ui/ui-joint-accounts" element={<UiJointAccounts />} />
            <Route
              path="/ui/filtered-activities-empty"
              element={<UiAccountsFilterEmpty />}
            />
            <Route path="/ui/ui-fixed-deposits" element={<UiFixedDeposits />} />
            <Route
              path="/ui/ui-fixed-deposits-empty"
              element={<UiFixedDepositEmpty />}
            />
            <Route
              path="/ui/ui-fixed-deposits-joint-accounts"
              element={<UiFixedDepositsJointAccounts />}
            />
            <Route path="/ui/loans" element={<UiLoans />} />
            <Route path="/ui/joint-loans" element={<UiJointLoans />} />
            <Route path="/ui/loans-empty" element={<UiLoansEmpty />} />
            <Route
              path="/ui/loans-empty-activities"
              element={<UiLoansEmptyActivities />}
            />
            <Route
              path="/ui/empty-credit-card"
              element={<UiEmptyCreditCard />}
            />
            <Route path="/ui/credit-cards" element={<UiCreditCards />} />
            <Route
              path="/ui/credit-cards-details-error"
              element={<UiCreditCardsDetailsError />}
            />
            <Route path="/ui/bill-payments" element={<UiBillPayments />} />
            <Route
              path="/ui/bill-payment-form"
              element={<UiBillPaymentform />}
            />
            <Route
              path="/ui/bill-payment-form-filled"
              element={<UiBillPaymentformFilled />}
            />
            <Route
              path="/ui/bill-transaction-confirmation"
              element={<UiTransactionConfirmation />}
            />
            <Route
              path="/ui/bill-payment-successful"
              element={<UiBillPaymentSuccessful />}
            />
            <Route
              path="/ui/bill-payment-unsuccessful"
              element={<UiBillPaymentUnSuccessful />}
            />
            <Route
              path="/ui/bill-payment-pending"
              element={<UiBillPaymentPending />}
            />
            <Route
              path="/ui/bill-payment-receipt"
              element={<UiBillPaymentReceipt />}
            />
            <Route
              path="/ui/bill-payment-empty"
              element={<UiBillPaymentsEmpty />}
            />
            <Route
              path="/ui/bill-payment-category-empty"
              element={<UiBillPaymentsCategoryEmpty />}
            />
            <Route
              path="/ui/bill-payment-search-empty"
              element={<UiBillPaymentsSearchEmpty />}
            />
            <Route
              path="/ui/card-bill-payment-form-own-adhoc"
              element={<UiCardBillPaymentOwn />}
            />
            <Route
              path="/ui/card-bill-payment-form-own-adhoc-filled"
              element={<UiCardBillPaymentOwnFilled />}
            />
            <Route
              path="/ui/bill-transaction-confirmation-own-adhoc"
              element={<UiTransactionConfirmationOwnAdhoc />}
            />
            <Route
              path="/ui/bill-transaction-success-own-adhoc"
              element={<UiBillPaymentSuccessfulOwnAdhoc />}
            />
            <Route
              path="/ui/bill-receipt-own-adhoc"
              element={<UiBillPaymentReceiptOwnAdhoc />}
            />
            <Route
              path="/ui/card-bill-payment-form-other-adhoc"
              element={<UiCardBillPaymentOther />}
            />
            <Route
              path="/ui/card-bill-payment-other-bank"
              element={<UiCardBillPaymentOtherBank />}
            />
            <Route
              path="/ui/card-bill-payment-other-bank-filled"
              element={<UiCardBillPaymentOtherBankFilled />}
            />
            <Route
              path="/ui/bill-payment-success-other-banks"
              element={<UiBillPaymentSuccessOtherBanks />}
            />
            <Route
              path="/ui/bill-receipt-other-banks"
              element={<UiBillPaymentReceiptOtherBanks />}
            />
            <Route
              path="/ui/bill-with-outstanding"
              element={<UiCardBillPaymentWithOutstanding />}
            />
            <Route path="/ui/bill-payments" element={<UiBillPayments />} />
            <Route
              path="/ui/bill-payment-form"
              element={<UiBillPaymentform />}
            />
            <Route
              path="/ui/bill-payment-form-filled"
              element={<UiBillPaymentformFilled />}
            />
            <Route
              path="/ui/bill-transaction-confirmation"
              element={<UiTransactionConfirmation />}
            />
            <Route
              path="/ui/bill-payment-successful"
              element={<UiBillPaymentSuccessful />}
            />
            <Route
              path="/ui/bill-payment-successful-nickname"
              element={<UiBillPaymentSuccessfulWithNickname />}
            />
            <Route
              path="/ui/bill-payment-unsuccessful"
              element={<UiBillPaymentUnSuccessful />}
            />
            <Route
              path="/ui/bill-payment-pending"
              element={<UiBillPaymentPending />}
            />
            <Route
              path="/ui/bill-payment-receipt"
              element={<UiBillPaymentReceipt />}
            />
            <Route
              path="/ui/bill-payment-empty"
              element={<UiBillPaymentsEmpty />}
            />
            <Route
              path="/ui/bill-payment-category-empty"
              element={<UiBillPaymentsCategoryEmpty />}
            />
            <Route
              path="/ui/bill-payment-search-empty"
              element={<UiBillPaymentsSearchEmpty />}
            />
            <Route
              path="/ui/card-bill-payment-form-own-adhoc"
              element={<UiCardBillPaymentOwn />}
            />
            <Route
              path="/ui/card-bill-payment-form-own-adhoc-filled"
              element={<UiCardBillPaymentOwnFilled />}
            />
            <Route
              path="/ui/bill-transaction-confirmation-own-adhoc"
              element={<UiTransactionConfirmationOwnAdhoc />}
            />
            <Route
              path="/ui/bill-transaction-success-own-adhoc"
              element={<UiBillPaymentSuccessfulOwnAdhoc />}
            />
            <Route
              path="/ui/bill-receipt-own-adhoc"
              element={<UiBillPaymentReceiptOwnAdhoc />}
            />
            <Route
              path="/ui/card-bill-payment-form-other-adhoc"
              element={<UiCardBillPaymentOther />}
            />
            <Route
              path="/ui/card-bill-payment-other-bank"
              element={<UiCardBillPaymentOtherBank />}
            />
            <Route
              path="/ui/card-bill-payment-other-bank-filled"
              element={<UiCardBillPaymentOtherBankFilled />}
            />
            <Route
              path="/ui/bill-payment-success-other-banks"
              element={<UiBillPaymentSuccessOtherBanks />}
            />
            <Route
              path="/ui/bill-receipt-other-banks"
              element={<UiBillPaymentReceiptOtherBanks />}
            />
            <Route
              path="/ui/bill-with-outstanding"
              element={<UiCardBillPaymentWithOutstanding />}
            />
            <Route
              path="/ui/bill-payment-favourite"
              element={<BillerFavouriteDashboard />}
            />
            <Route
              path="/ui/bill-payment-favourite-form"
              element={<UiFavouriteBillPaymentform />}
            />
            <Route
              path="/ui/bill-payment-favourite-empty"
              element={<BillerFavouriteDashboardEmpty />}
            />
            <Route
              path="/ui/bill-payment-favourite-empty-with-search"
              element={<BillerFavouriteDashboardEmptyWithSearch />}
            />
            <Route
              path="/ui/bill-payment-favourite-form-with-outstanding"
              element={<UiFavouriteBillPaymentformWithOutstanding />}
            />
            <Route
              path="/ui/bill-payment-favourite-empty-activity"
              element={<UiFavouriteBillPaymentsEmptyActivity />}
            />
            <Route
              path="/ui/bill-payment-favourite-empty-activity-filtered"
              element={<UiFavouriteBillPaymentsEmptyActivityFiltered />}
            />
            <Route
              path="/ui/bill-payment-favourite-form-edit"
              element={<UiFavouriteBillPaymentEdit />}
            />
            <Route
              path="/ui/bill-payment-empty-favourite"
              element={<UiBillPaymentsEmptyFavourite />}
            />
            <Route
              path="/ui/unregistered-biller-as-favourite-success"
              element={
                <UiAddUnregisteredBillerAsFavouriteEndTransactionSuccess />
              }
            />
            <Route
              path="/ui/unregistered-biller-as-favourite-pending"
              element={
                <UiAddUnregisteredBillerAsFavouriteEndTransactionPending />
              }
            />
            <Route path="/ui/my-wallet" element={<UiMyWallet />} />
            <Route path="/ui/my-wallet-empty" element={<UiMyWalletEmpty />} />
            <Route
              path="/ui/fund-tranfer-payee-favourite"
              element={<UiPayeeFavouriteForm />}
            />
            <Route
              path="/ui/fund-tranfer-payee-favourite-confirmation"
              element={<UiPayeeFavouriteConfirmation />}
            />
            <Route
              path="/ui/fund-tranfer-payee-favourite-successful"
              element={<UiPayeeFavouriteSuccessful />}
            />
            <Route
              path="/ui/fund-tranfer-payee-favourite-unregistered-successful"
              element={<UiAddUnregisteredBillerAsFavouriteSuccess />}
            />
            <Route
              path="/ui/fund-tranfer-payee-favourite-pay-from-account"
              element={<UiPayeeFavouriteFormPayfromAccount />}
            />
            <Route
              path="/ui/fund-tranfer-payee-favourite-empty-activities"
              element={<UiPayeeFavouriteEmtpyActivities />}
            />
            <Route
              path="/ui/fund-tranfer-payee-favourite-empty-activities-filtered"
              element={<UiPayeeFavouriteEmtpyActivitiesFiltered />}
            />
            <Route
              path="/ui/fund-tranfer-payee-favourite-edit"
              element={<UiPayeeFavouriteFormEdit />}
            />
            <Route
              path="/ui/fund-transfer-dashboard"
              element={<UiFundTransferDashboard />}
            />
            <Route
              path="/ui/fund-transfer-dashboard-filled"
              element={<UiFundTransferDashboardFilled />}
            />
            <Route
              path="/ui/fund-transfer-successful"
              element={<UiFundTransferSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-unsuccessful"
              element={<UiFundTransferUnSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-receipt"
              element={<UiFundTransferReceipt />}
            />
            <Route
              path="/ui/fund-transfer-successful-notification"
              element={<UiFundTransferSuccessfulNotification />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-acc"
              element={<UiFundTransferOtherBankAccount />}
            />
            <Route
              path="/ui/fund-transfer-empty-scrren"
              element={<UiFundTransferDashboardEmptyScreen />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-successful"
              element={<UiFundTransferOtherBankSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-transaction-confirmation"
              element={<UiFundTransferTransactionConfirmation />}
            />
            <Route
              path="/ui/fund-transfer-other-acc"
              element={<UiFundTransferOtherAccount />}
            />
            <Route
              path="/ui/fund-transfer-other-acc-transaction-confirmation"
              element={<UiFundTransferOtherAccTransactionConfirmation />}
            />
            <Route
              path="/ui/fund-transfer-other-acc-receipt"
              element={<UiFundTransferOtherAccReceipt />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-receipt"
              element={<UiFundTransferOtherBankReceipt />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-transaction-confirmation"
              element={<UiFundTransferOtherBankTransactionConfirmation />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-unsuccessful"
              element={<UiFundTransferOtherBankUnSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-pending"
              element={<UiFundTransferOtherBankPending />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency"
              element={<UiFundTransferCrossCurrency />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-filled"
              element={<UiFundTransferCrossCurrencyFilled />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-success"
              element={<UiFundTransferCrossCurrencySuccess />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-confirm"
              element={<UiFundTransferCrossCurrencyConfirmation />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-unsuccess"
              element={<UiFundTransferCrossCurrencyUnSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-receipt"
              element={<UiFundTransferCrossCurrencyReceipt />}
            />
            <Route
              path="/ui/fund-transfer-history-successful"
              element={<UiFundTransferHistorySuccessful />}
            />
            <Route
              path="/ui/fund-transfer-history-unsuccessful"
              element={<UiFundTransferHistoryUnSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-history-pending"
              element={<UiFundTransferHistoryPending />}
            />
            <Route
              path="/ui/fund-transfer-purpose"
              element={<UiFundTransferPurpose />}
            />
            <Route
              path="/ui/fund-transfer-purpose-confirm"
              element={<UiFundTransferPurposeConfirm />}
            />
            <Route
              path="/ui/fund-transfer-bank-empty"
              element={<UiSelectBankEmpty />}
            />
            <Route
              path="/ui/transfer-limit-dashboard"
              element={<TransferLimitDashboard />}
            />
            <Route
              path="/ui/application-settings"
              element={<UiApplicationSettings />}
            />
            <Route path="/ui/new-password" element={<UiNewPassword />} />
            <Route
              path="/ui/create-new-password"
              element={<UiCreateNewPassword />}
            />
            <Route path="/ui/otp-preference" element={<UiOtpPreference />} />
            <Route
              path="/ui/otp-preference-disable"
              element={<UiOtpRadioDisable />}
            />
            <Route
              path="/ui/otp-preference-remove"
              element={<UiOtpCbsRemove />}
            />
            <Route
              path="/ui/transfer-limit-preference"
              element={<UiTransferLimitPreference />}
            />
            <Route path="/ui/own-account" element={<UiOwnAccountTransfer />} />
            <Route
              path="/ui/account-preference"
              element={<UiAccountPreferences />}
            />
            <Route
              path="/ui/credit-card-preference"
              element={<UiCreditCardPreferences />}
            />
            <Route
              path="/ui/set-default-account"
              element={<UiSetDefaultAccount />}
            />
            <Route
              path="/ui/set-account-nickname"
              element={<UiSetAccountNickname />}
            />
            <Route
              path="/ui/change-account-nickname"
              element={<UiChangeAccountNickname />}
            />
            <Route
              path="/ui/notification-settings"
              element={<UiNotificationSettings />}
            />
            <Route path="/ui/admit-limit-null" element={<UiAdmitLimitNull />} />
            <Route
              path="/ui/transfer-empty-screen"
              element={<UiTransferEmpty />}
            />
            <Route
              path="/ui/notification-settings-empty"
              element={<UiNotificationSettingEmpty />}
            />
            <Route
              path="/ui/account-preferences-empty"
              element={<UiAccountPreferencesEmpty />}
            />
            <Route path="/ui/nicknames-empty" element={<UiNickNamesEmpty />} />
            <Route
              path="/ui/nicknames-empty-tab"
              element={<UiNickNamesTabEmpty />}
            />
            <Route
              path="/ui/credit-card-preference-empty"
              element={<UiCreditCardPreferenceEmpty />}
            />
            <Route
              path="/ui/default-account-empty"
              element={<UiDefaultAccountEmpty />}
            />
            <Route
              path="/ui/fund-transfer-dashboard"
              element={<UiFundTransferDashboard />}
            />
            <Route
              path="/ui/fund-transfer-dashboard-filled"
              element={<UiFundTransferDashboardFilled />}
            />
            <Route
              path="/ui/fund-transfer-successful"
              element={<UiFundTransferSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-unsuccessful"
              element={<UiFundTransferUnSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-receipt"
              element={<UiFundTransferReceipt />}
            />
            <Route
              path="/ui/fund-transfer-successful-notification"
              element={<UiFundTransferSuccessfulNotification />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-acc"
              element={<UiFundTransferOtherBankAccount />}
            />
            <Route
              path="/ui/fund-transfer-empty-scrren"
              element={<UiFundTransferDashboardEmptyScreen />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-successful"
              element={<UiFundTransferOtherBankSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-transaction-confirmation"
              element={<UiFundTransferTransactionConfirmation />}
            />
            <Route
              path="/ui/fund-transfer-other-acc"
              element={<UiFundTransferOtherAccount />}
            />
            <Route
              path="/ui/fund-transfer-other-acc-transaction-confirmation"
              element={<UiFundTransferOtherAccTransactionConfirmation />}
            />
            <Route
              path="/ui/fund-transfer-other-acc-receipt"
              element={<UiFundTransferOtherAccReceipt />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-receipt"
              element={<UiFundTransferOtherBankReceipt />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-transaction-confirmation"
              element={<UiFundTransferOtherBankTransactionConfirmation />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-unsuccessful"
              element={<UiFundTransferOtherBankUnSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-other-bank-pending"
              element={<UiFundTransferOtherBankPending />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency"
              element={<UiFundTransferCrossCurrency />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-filled"
              element={<UiFundTransferCrossCurrencyFilled />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-success"
              element={<UiFundTransferCrossCurrencySuccess />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-confirm"
              element={<UiFundTransferCrossCurrencyConfirmation />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-unsuccess"
              element={<UiFundTransferCrossCurrencyUnSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-cross-currency-receipt"
              element={<UiFundTransferCrossCurrencyReceipt />}
            />
            <Route
              path="/ui/fund-transfer-history-successful"
              element={<UiFundTransferHistorySuccessful />}
            />
            <Route
              path="/ui/fund-transfer-history-unsuccessful"
              element={<UiFundTransferHistoryUnSuccessful />}
            />
            <Route
              path="/ui/fund-transfer-history-pending"
              element={<UiFundTransferHistoryPending />}
            />
            <Route
              path="/ui/fund-transfer-purpose"
              element={<UiFundTransferPurpose />}
            />
            <Route
              path="/ui/fund-transfer-purpose-confirm"
              element={<UiFundTransferPurposeConfirm />}
            />
            <Route
              path="/ui/fund-transfer-bank-empty"
              element={<UiSelectBankEmpty />}
            />
            <Route
              path="/ui/transfer-limit-dashboard"
              element={<TransferLimitDashboard />}
            />
            <Route
              path="/ui/application-settings"
              element={<UiApplicationSettings />}
            />
            <Route path="/ui/new-password" element={<UiNewPassword />} />
            <Route
              path="/ui/create-new-password"
              element={<UiCreateNewPassword />}
            />
            <Route path="/ui/otp-preference" element={<UiOtpPreference />} />
            <Route
              path="/ui/otp-preference-disable"
              element={<UiOtpRadioDisable />}
            />
            <Route
              path="/ui/otp-preference-remove"
              element={<UiOtpCbsRemove />}
            />
            <Route
              path="/ui/transfer-limit-preference"
              element={<UiTransferLimitPreference />}
            />
            <Route path="/ui/own-account" element={<UiOwnAccountTransfer />} />
            <Route
              path="/ui/account-preference"
              element={<UiAccountPreferences />}
            />
            <Route
              path="/ui/credit-card-preference"
              element={<UiCreditCardPreferences />}
            />
            <Route
              path="/ui/set-default-account"
              element={<UiSetDefaultAccount />}
            />
            <Route
              path="/ui/set-account-nickname"
              element={<UiSetAccountNickname />}
            />
            <Route
              path="/ui/change-account-nickname"
              element={<UiChangeAccountNickname />}
            />
            <Route
              path="/ui/notification-settings"
              element={<UiNotificationSettings />}
            />
            <Route path="/ui/admit-limit-null" element={<UiAdmitLimitNull />} />
            <Route
              path="/ui/transfer-empty-screen"
              element={<UiTransferEmpty />}
            />
            <Route
              path="/ui/notification-settings-empty"
              element={<UiNotificationSettingEmpty />}
            />
            <Route
              path="/ui/account-preferences-empty"
              element={<UiAccountPreferencesEmpty />}
            />
            <Route path="/ui/nicknames-empty" element={<UiNickNamesEmpty />} />
            <Route
              path="/ui/nicknames-empty-tab"
              element={<UiNickNamesTabEmpty />}
            />
            <Route
              path="/ui/credit-card-preference-empty"
              element={<UiCreditCardPreferenceEmpty />}
            />
            <Route
              path="/ui/default-account-empty"
              element={<UiDefaultAccountEmpty />}
            />
            <Route path="/ui/nic-begin" element={<UiNicBegin />} />
            <Route path="/ui/not-customer" element={<UiNotCustomer />} />
            <Route path="/ui/radio-step-one" element={<UiRadioStepOne />} />
            <Route
              path="/ui/acc-no-step-two"
              element={<UiAccountNoStepTwo />}
            />
            <Route
              path="/ui/prefer-step-four"
              element={<UiPreferedStepFour />}
            />
            <Route
              path="/ui/verification-progress"
              element={<UiVerificationProgress />}
            />
            <Route
              path="/ui/username-step-five"
              element={<UiUsernameStepFive />}
            />
            <Route
              path="/ui/password-step-six"
              element={<UiPasswordStepSix />}
            />
            <Route path="/ui/name-step-seven" element={<UiNameStepSeven />} />
            <Route path="/ui/acc-ready" element={<UiAccountReady />} />
            <Route path="/ui/try-again" element={<UiTryAgain />} />
            <Route
              path="/ui/debit-card-detail"
              element={<UiDeditCardDetails />}
            />
            <Route
              path="/ui/credit-card-detail"
              element={<UiOnboardCreditCardDetails />}
            />
            <Route path="/ui/fixed-deposit" element={<UiFixedDeposit />} />
            <Route
              path="/ui/fixed-deposits-open"
              element={<UiOpenFixedDeposit />}
            />
            <Route
              path="/ui/fixed-deposits-open-filled"
              element={<UiOpenFixedDepositFilled />}
            />
            <Route
              path="/ui/fixed-deposits-open-confirm"
              element={<UiFixedDepositOpeningConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-open-success"
              element={<UiFixedDepositOpeningSuccess />}
            />
            <Route
              path="/ui/fixed-deposits-receipt"
              element={<UiFixedDepositReceipt />}
            />
            <Route
              path="/ui/fixed-deposits-amount-interest"
              element={<UiFixedDepositAmountInterestConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-renew-amount"
              element={<UiFixedDepositRenewAmountConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-closure"
              element={<UiFixedDepositClosure />}
            />
            <Route
              path="/ui/fixed-deposits-closure-success"
              element={<UiFixedDepositClosureSuccess />}
            />
            <Route
              path="/ui/fixed-deposits-closure-receipt"
              element={<UiFixedDepositClosureReceipt />}
            />
            <Route
              path="/ui/fixed-deposits-closure-confirm"
              element={<UiFixedDepositClosureConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-closure-progress"
              element={<UiFdProgress />}
            />
            <Route
              path="/ui/fixed-deposits-something-wrong"
              element={<UiFdSomethingWrong />}
            />
            <Route
              path="/ui/securemail-empty-dashboard"
              element={<UiSecureMailEmptyDashboard />}
            />
            <Route
              path="/ui/securemail-dashboard"
              element={<UiSecureMailDashboard />}
            />
            <Route path="/ui/create-new-mail" element={<UiCreateMail />} />
            <Route
              path="/ui/create-new-mail-with-attachment"
              element={<UiCreateMailWithAttachment />}
            />
            <Route
              path="/ui/securemail-dashboard-search-empty"
              element={<UiSecureMailDashboardSearchEmpty />}
            />
            <Route path="/ui/securemail-view" element={<UiViewMail />} />
            <Route
              path="/ui/securemail-view-closed"
              element={<UiViewMailClosed />}
            />
            <Route
              path="/ui/securemail-conversation-print"
              element={<UiSecureMailPrintConversation />}
            />
            <Route path="/ui/nic-begin" element={<UiNicBegin />} />
            <Route path="/ui/not-customer" element={<UiNotCustomer />} />
            <Route path="/ui/radio-step-one" element={<UiRadioStepOne />} />
            <Route
              path="/ui/acc-no-step-two"
              element={<UiAccountNoStepTwo />}
            />
            <Route
              path="/ui/prefer-step-four"
              element={<UiPreferedStepFour />}
            />
            <Route
              path="/ui/verification-progress"
              element={<UiVerificationProgress />}
            />
            <Route
              path="/ui/username-step-five"
              element={<UiUsernameStepFive />}
            />
            <Route
              path="/ui/password-step-six"
              element={<UiPasswordStepSix />}
            />
            <Route path="/ui/name-step-seven" element={<UiNameStepSeven />} />
            <Route path="/ui/acc-ready" element={<UiAccountReady />} />
            <Route path="/ui/try-again" element={<UiTryAgain />} />
            <Route
              path="/ui/debit-card-detail"
              element={<UiDeditCardDetails />}
            />
            <Route
              path="/ui/credit-card-detail"
              element={<UiOnboardCreditCardDetails />}
            />
            <Route path="/ui/fixed-deposit" element={<UiFixedDeposit />} />
            <Route
              path="/ui/fixed-deposits-open"
              element={<UiOpenFixedDeposit />}
            />
            <Route
              path="/ui/fixed-deposits-open-filled"
              element={<UiOpenFixedDepositFilled />}
            />
            <Route
              path="/ui/fixed-deposits-open-confirm"
              element={<UiFixedDepositOpeningConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-open-success"
              element={<UiFixedDepositOpeningSuccess />}
            />
            <Route
              path="/ui/fixed-deposits-receipt"
              element={<UiFixedDepositReceipt />}
            />
            <Route
              path="/ui/fixed-deposits-amount-interest"
              element={<UiFixedDepositAmountInterestConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-renew-amount"
              element={<UiFixedDepositRenewAmountConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-closure"
              element={<UiFixedDepositClosure />}
            />
            <Route
              path="/ui/fixed-deposits-closure-success"
              element={<UiFixedDepositClosureSuccess />}
            />
            <Route
              path="/ui/fixed-deposits-closure-receipt"
              element={<UiFixedDepositClosureReceipt />}
            />
            <Route
              path="/ui/fixed-deposits-closure-confirm"
              element={<UiFixedDepositClosureConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-closure-progress"
              element={<UiFdProgress />}
            />
            <Route
              path="/ui/fixed-deposits-something-wrong"
              element={<UiFdSomethingWrong />}
            />
            <Route
              path="/ui/securemail-empty-dashboard"
              element={<UiSecureMailEmptyDashboard />}
            />
            <Route
              path="/ui/securemail-dashboard"
              element={<UiSecureMailDashboard />}
            />
            <Route path="/ui/create-new-mail" element={<UiCreateMail />} />
            <Route
              path="/ui/create-new-mail-with-attachment"
              element={<UiCreateMailWithAttachment />}
            />
            <Route
              path="/ui/securemail-dashboard-search-empty"
              element={<UiSecureMailDashboardSearchEmpty />}
            />
            <Route path="/ui/securemail-view" element={<UiViewMail />} />
            <Route
              path="/ui/securemail-view-closed"
              element={<UiViewMailClosed />}
            />
            <Route
              path="/ui/fixed-deposits-closure-receipt"
              element={<UiFixedDepositClosureReceipt />}
            />
            <Route
              path="/ui/fixed-deposits-closure-confirm"
              element={<UiFixedDepositClosureConfirm />}
            />
            <Route
              path="/ui/fixed-deposits-closure-progress"
              element={<UiFdProgress />}
            />
            <Route
              path="/ui/fixed-deposits-something-wrong"
              element={<UiFdSomethingWrong />}
            />
            <Route
              path="/ui/securemail-empty-dashboard"
              element={<UiSecureMailEmptyDashboard />}
            />
            <Route
              path="/ui/securemail-dashboard"
              element={<UiSecureMailDashboard />}
            />
            <Route path="/ui/create-new-mail" element={<UiCreateMail />} />
            <Route
              path="/ui/create-new-mail-with-attachment"
              element={<UiCreateMailWithAttachment />}
            />
            <Route
              path="/ui/securemail-dashboard-search-empty"
              element={<UiSecureMailDashboardSearchEmpty />}
            />
            <Route path="/ui/securemail-view" element={<UiViewMail />} />
            <Route
              path="/ui/securemail-view-closed"
              element={<UiViewMailClosed />}
            />
            <Route
              path="/ui/savings-goal-open"
              element={<UiSavingsGoalOpen />}
            />
            <Route
              path="/ui/create-savings-goal"
              element={<UiCreateSavingsGoal />}
            />
            <Route
              path="/ui/create-savings-goal-form"
              element={<UiCreateSavingsGoalsForm />}
            />
            <Route
              path="/ui/savings-goal-confirm"
              element={<UiSavingsGoalOpeningConfirmation />}
            />
            <Route
              path="/ui/savings-goal-success"
              element={<UiSavingsGoalOpeningSuccess />}
            />
            <Route
              path="/ui/savings-goal-receipt"
              element={<UiSavingsGoalReceipt />}
            />
            <Route
              path="/ui/savings-account-opening"
              element={<UiOpenSavingsAccount />}
            />
            <Route
              path="/ui/savings-account-opening-confirmation"
              element={<UiSavingsAccountOpeningConfirmation />}
            />
            <Route
              path="/ui/savings-account-opening-successful"
              element={<UiSavingsAccountCreatedSuccess />}
            />
            <Route
              path="/ui/savings-account-something-wrong"
              element={<UiSavingsAccountSomethingWrong />}
            />
            <Route
              path="/ui/savings-account-opening-successful-2"
              element={<UiSavingsAccountCreatedSuccess2 />}
            />
            <Route
              path="/ui/savings-account-opening-successful-3"
              element={<UiSavingsAccountCreatedSuccess3 />}
            />
            <Route
              path="/ui/savings-account-opening"
              element={<UiOpenSavingsAccount />}
            />
            <Route
              path="/ui/savings-account-opening-confirmation"
              element={<UiSavingsAccountOpeningConfirmation />}
            />
            <Route
              path="/ui/savings-account-opening-successful"
              element={<UiSavingsAccountCreatedSuccess />}
            />
            <Route
              path="/ui/savings-account-something-wrong"
              element={<UiSavingsAccountSomethingWrong />}
            />
            <Route
              path="/ui/savings-account-opening-successful-2"
              element={<UiSavingsAccountCreatedSuccess2 />}
            />
            <Route
              path="/ui/savings-account-opening-successful-3"
              element={<UiSavingsAccountCreatedSuccess3 />}
            />
            <Route
              path="/ui/savings-goal-open-empty"
              element={<UiSavingsGoalOpenEmpty />}
            />
            <Route
              path="/ui/savings-goal-detail-empty"
              element={<UiSavingsGoalDetailEmpty />}
            />
            <Route
              path="/ui/savings-goal-closure"
              element={<UiSavingsGoalClosure />}
            />
            <Route
              path="/ui/savings-goal-closure-confirm"
              element={<UiSavingsGoalClosureConfirmation />}
            />
            <Route
              path="/ui/savings-goal-closure-progress"
              element={<UiSavingsGoalProgress />}
            />
            <Route
              path="/ui/savings-goal-closed-success"
              element={<UiSavingsGoalClosedSuccess />}
            />
            <Route
              path="/ui/savings-goal-closed-receipt"
              element={<UiSavingsGoalClosureReceipt />}
            />
            <Route
              path="/ui/savings-goal-closed-fd"
              element={<UiOpenFdPrincipalAmount />}
            />
            <Route path="/ui/portfolio" element={<UiPortfolioDashboard />} />
            <Route
              path="/ui/notifications-empty"
              element={<UiNotificationsEmpty />}
            />
            <Route
              path="/ui/notifications-error"
              element={<UiNotificationsError />}
            />
            <Route path="/ui/lease" element={<UiLease />} />
            <Route path="/ui/lease-empty" element={<UiLeaseEmpty />} />
            <Route path="/ui/history" element={<UiHistory />} />
            <Route path="/ui/history-empty" element={<UiHistoryEmpty />} />
            <Route
              path="/ui/history-search-empty"
              element={<UiHistorySearchEmpty />}
            />
            <Route
              path="/ui/notifications-error"
              element={<UiNotificationsError />}
            />
            <Route
              path="/ui/portfolio-savings-acc"
              element={<UiPortfolioSavingsAccounts />}
            />
            <Route
              path="/ui/portfolio-fd"
              element={<UiPortfolioFixedDeposit />}
            />
            <Route
              path="/ui/service-accounts"
              element={<UiServiceAccounts />}
            />
            <Route
              path="/ui/service-stop-cheque"
              element={<UiServiceRequestStop />}
            />
            <Route path="/ui/stop-cheque-form" element={<UiStopChequeForm />} />
            <Route
              path="/ui/service-req-confirm"
              element={<UiServiceRequestConfirmation />}
            />
            <Route
              path="/ui/service-req-success"
              element={<UiServiceRequestSuccess />}
            />
            <Route
              path="/ui/service-req-failed"
              element={<UiServiceRequestFailed />}
            />
            <Route
              path="/ui/service-some-wrong"
              element={<UiServiceSomethingWrong />}
            />
            <Route
              path="/ui/service-request-empty"
              element={<UiServiceRequestEmpty />}
            />
            <Route path="/ui/service-request" element={<UiServiceRequest />} />
            <Route
              path="/ui/service-request-filter-empty"
              element={<UiServiceRequestFilterEmpty />}
            />
            <Route path="/ui/lease" element={<UiLease />} />
            <Route
              path="/ui/service-request-form"
              element={<UiServiceRequestForm />}
            />
            <Route
              path="/ui/service-request-confirmation"
              element={<UiServiceRequestCommonConfirmation />}
            />
            <Route
              path="/ui/service-request-dashboard"
              element={<UiServiceRequestDashboard />}
            />
            <Route
              path="/ui/service-request-common-empty"
              element={<UiServiceRequestCommonEmpty />}
            />
            <Route
              path="/ui/service-request-stop-cheque"
              element={<UiServiceRequestStopCheque />}
            />
            <Route
              path="/ui/service-request-cheque-book"
              element={<UiServiceRequestChequeBook />}
            />
            <Route
              path="/ui/service-stop-cheque-range"
              element={<UiServiceStopChequeRange />}
            />

            <Route
              path="/ui/stop-cheque-confirmation"
              element={<UiStopChequeConfirmation />}
            />
            <Route
              path="/ui/debit-card-list"
              element={<UiServiceDebitCardList />}
            />
            <Route path="/ui/country-list" element={<UiServiceCountryList />} />
            {/* traffic fines */}
            <Route path="/ui/traffic-fines" element={<UiTrafficFines />} />
            <Route
              path="/ui/traffic-fines-form"
              element={<UiTrafficFinesForm />}
            />
            <Route
              path="/ui/traffic-fines-trasaction-confirmation"
              element={<UiTrafficFinesTransactionConfirmation />}
            />
            <Route
              path="/ui/traffic-fines-trasaction-success"
              element={<UiTrafficFinesTransactionSuccessful />}
            />
            <Route
              path="/ui/traffic-fines-trasaction-failed"
              element={<UiTrafficFinesTransactionUnsuccessful />}
            />
            <Route
              path="/ui/traffic-fines-receipt"
              element={<UiTrafficFinesReceipt />}
            />
            <Route
              path="/ui/lppop-bill-payment-dashboard"
              element={<UiLppopBillPaymentDashboard />}
            />
            <Route path="/ui/slcustom-form" element={<UiSlCustomForm />} />
            <Route
              path="/ui/slcustom-transaction-confirmation"
              element={<UiSlTransactionConfirmation />}
            />
            <Route
              path="/ui/slcustom-success"
              element={<UiSlCustomsSuccess />}
            />
            <Route
              path="/ui/slcustom-pending"
              element={<UiSlCustomPending />}
            />
            <Route
              path="/ui/slcustom-unsuccess"
              element={<UiSlCustomUnsuccess />}
            />
            <Route
              path="/ui/slcustom-almost-there"
              element={<UiSlCustomAlmostThere />}
            />
            <Route path="/ui/ird-form" element={<UiIrdForm />} />

            <Route
              path="/ui/view-checkbook-status"
              element={<UiViewChequeBookStatus />}
            />

            <Route
              path="/ui/account-statement"
              element={<UiAccountStatement />}
            />

            <Route path="/ui/dashboard-empty" element={<UiDashboardEmpty />} />

            <Route path="/ui/schedule-payments-popup" element={<SchedulePaymentsPopup />} />

            <Route path="/ui/schedule-payments-main" element={<SchedulePaymentsMain />} />

            <Route path="/ui/schedule-payments-main-empty" element={<SchedulePaymentsMainEmpty />} />

            <Route path="/ui/schedule-detail" element={<ScheduleDetail />} />

            <Route path="/ui/schedule-detail-insufficient" element={<ScheduleDetailInsufficient />} />

            <Route path="/ui/schedule-detail-empty" element={<ScheduleDetailEmpty />} />

            <Route path="/ui/schedule-payments-success" element={<UiSchedulePaymentsSuccess />} />

            <Route path="/ui/schedule-payments-move" element={<SchedulePaymentsMove/>} />

            <Route path="/ui/schedule-detail-retry-success" element={<ScheduleDetailRetrySuccess />} />

            <Route path="/ui/forgot-password" element={<UiForgotPassword />} />

            <Route path="/ui/forgot-username-loader" element={<UiForgotUsernameLoader />} />

            <Route path="/ui/joy-ride-peek-balance" element={<UiJoyRidePeekBalance />} />

            <Route path="/ui/joy-ride-bill-payments" element={<UiJoyRideBillPayments />} />

            <Route path="/ui/joy-ride-send-money" element={<UiJoyRideSendMoney />} />
          </>
        )}
      </Routes>
    </Fragment>
  );
};

export default RoutesComponent;
